<template>
  <div class="ym-wx-open-launch-app">
    <wx-open-launch-app v-if="inWeiXinBrowser"
                        appid="wxc54cc63eb23298e3"
                        @error="handleError"
                        @launch="handleLaunch"
                        :extinfo="url"
    >
      <slot name="button"></slot>
    </wx-open-launch-app>
    <div v-else
         @click="handleOpenApp"
    >
      <slot></slot>
    </div>
  </div>
</template>

<script>
  import {
    isWeiXinBrowser,
    locationHref,
    isAppWebView,
    handleRedirectAPPPage,
  } from '@/utils';

  export default {
    name: 'YmWxOpenLaunchApp',
    props: {
      url: {
        type: String,
        required: true,
      },
    },
    computed: {
      inWeiXinBrowser() {
        return isWeiXinBrowser();
      },
      oiaAppLink() {
        return `https://oia.youthmba.com/download/app?scheme=${this.url}`;
      },
    },
    methods: {
      handleError(e) {
        console.log('error', e, this.url);
        locationHref(this.oiaAppLink);
      },
      handleLaunch(e) {
        this.$emit('success', e);
      },
      handleOpenApp() {
        if (isAppWebView()) {
          handleRedirectAPPPage(this.url);
          return;
        }
        locationHref(this.oiaAppLink);
      },
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

</style>
